<template>
  <v-navigation-drawer
    app
    clipped
    v-model="DRAWER_STATE"
    :mini-variant="!DRAWER_STATE"
    :width="sidebarWidth"
    :permanent="$vuetify.breakpoint.lgAndUp"
    :temporary="$vuetify.breakpoint.mdAndDown"
    :mini-variant-width="sidebarMinWidth"
    :class="{'drawer-mini': !DRAWER_STATE}"
  >
    <v-list>
      <template v-for="(item, i) in items">
        <v-row
          v-if="item.heading"
          :key="item.heading"
        >
          <v-col cols="6">
            <span
              style="padding-left: 32px"
              class="text-body-1 subheader"
              :class="(item.heading && DRAWER_STATE) ? 'show ' : 'hide'">
              {{ item.heading }}
            </span>
          </v-col>
          <v-col
            cols="6"
            class="text-center"
          >
          </v-col>
        </v-row>
        <v-divider
          v-else-if="item.divider"
          :key="i"
          dark
          class="my-4"
        ></v-divider>
        <v-list-group
          color="primary"
          v-else-if="item.children && DRAWER_STATE"
          :key="item.title"
          v-model="item.model"
        >

          <template v-slot:prependIcon>
            <v-icon size="24" class="mr-0" color="greyTint"> {{ item.icon }} </v-icon>
          </template>
          <template v-slot:activator >
            <v-list-item-content>
              <v-badge v-if="item.badge" content="New" color="secondary">
              </v-badge>
                <v-list-item-title>
                  {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-show="!item.type"
            v-for="(child, i) in item.children"
            :key="i + child.title"
            :to="child.link"
            link
            class="pl-12"
            @click="child.action ? child.action() : null"
          >
            <v-list-item-action class="mr-2" v-if="child.icon">
              <v-icon size="">{{ child.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-title>
                  {{ child.title }}
                </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <template v-if="item.type">
            <v-list-group
              v-for="(item, i) in item.children"
              :key="i"
              :value="true"
              no-action
              sub-group
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                  v-for="(child, i) in item.children"
                  :key="i"
                  :to="child.link"
                  link
                  @click="child.action ? child.action() : null"
              >
                <v-list-item-title v-text="child.title"></v-list-item-title>
              </v-list-item>
            </v-list-group>
          </template>
        </v-list-group>
        <v-list-item
          color="primary"
          v-else
          :key="item.text"
          :href="item.href ? item.href : null"
          :to="item.link === '#' ? '' : item.link"
          @click="item.action ? item.action() : null"
          link
        >
          <v-list-item-action class="mr-6">
            <v-icon
              :size="item.size ? item.size : 24"
              :color="item.color ? item.color : 'greyTint'"
            >{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title
              link
            >
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <v-divider
        dark
        style="margin-top: 10px;"
      ></v-divider>
      <v-list-item
        color="primary"
        link
        @click="openChat">
        <v-list-item-action class="mr-6">
          <v-avatar size="35">
            <v-img :src="chatxc"></v-img>
          </v-avatar>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title
            link style="font-size: 12pt; font-weight: 700">
            ChatXC
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>


<script>
  import { mapActions, mapState } from 'vuex'

  export default {
    props: {
        source: String,
    },
    data(){
      return {
        items: [],
        menu_items: {
          'Dashboard': { heading: 0, title: 'Dashboard', icon: 'mdi-home', link: '/dashboard', action: () => this.TOGGLE_DRAWER()},
          'Directory': { heading: 0, title: 'Directory', icon: 'mdi-contacts', link: '/directory', action: () => this.TOGGLE_DRAWER()},
          'Documents': { heading: 0, title: 'Documents', icon: 'mdi-folder-multiple-plus', link: '/document/list', action: () => this.TOGGLE_DRAWER()},
          'ShiftSchedule': { heading: 0, title: 'Shift Schedule', icon: 'mdi-calendar-clock', link: '/shiftschedule', action: () => this.TOGGLE_DRAWER()},
          'Manufacturing': {
            title: 'Manufacturing',
            icon: 'mdi-factory',
            model: false,
            action: () => this.TOGGLE_DRAWER(),
            type: 'sub-menu',
            children: [
              { 
                  title: 'Material',
                  icon: 'mdi-circle-small',
                  children: [
                    { title: 'Material List', icon: 'mdi-circle-small', link: '/material/list', action: () => this.TOGGLE_DRAWER()},
                    { title: 'Bill of Materials', icon: 'mdi-circle-small', link: '/billmaterial/list', action: () => this.TOGGLE_DRAWER()},
              ]},
              { 
                  title: 'Production',
                  icon: 'mdi-circle-small',
                  children: [
                  { title: 'Production Orders', icon: 'mdi-circle-small', link: '/productionorder/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Production Adjustment', icon: 'mdi-circle-small', link: '/productionadjustment/list', action: () => this.TOGGLE_DRAWER()},
              ]},
              { 
                  title: 'Inventory',
                  icon: 'mdi-circle-small',
                  children: [
                  { title: 'Inventory', icon: 'mdi-circle-small', link: '/inventory/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Inventory Transfer', icon: 'mdi-circle-small', link: '/inventorytransfer/list', action: () => this.TOGGLE_DRAWER()},
              ]},
            ],
          },
          'Sales': {
            title: 'Sales',
            icon: 'mdi-store',
            model: false,
            action: () => this.TOGGLE_DRAWER(),
            type: 'sub-menu',
            children: [
              { 
                title: 'Customers',
                icon: 'mdi-circle-small',
                children: [
                  { title: 'Customers', icon: 'mdi-store', link: '/customer/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Active', icon: 'mdi-store', link: '/customer/active/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Visits', icon: 'mdi-tooltip-account', link: '/visit/list', action: () => this.TOGGLE_DRAWER()},
              ]},
              {
                title: 'Orders',
                icon: 'mdi-circle-small',
                model: false,
                children: [
                  { title: 'Sales Orders', icon: 'mdi-text-box-multiple', link: '/salesorder/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Sales Costs', icon: 'mdi-text-box-multiple', link: '/salescost/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Route Plans', icon: 'mdi-text-box-multiple', link: '/routeplan/list', action: () => this.TOGGLE_DRAWER()},             
                ],
              },
              {
                title: 'Administration',
                icon: 'mdi-circle-small',
                model: false,
                children: [
                  { title: 'Sales Reps', icon: 'mdi-text-box-multiple', link: '/salesrep/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Routes', icon: 'mdi-circle-small', link: '/route/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Sales Targets', icon: 'mdi-cash-check', link: '/salestarget/list', action: () => this.TOGGLE_DRAWER()},  
                  { title: 'Sales Channels', icon: 'mdi-cash-check', link: '/saleschannel/list', action: () => this.TOGGLE_DRAWER()},                ],
              },
              {
                title: 'Products',
                icon: 'mdi-circle-small',
                model: false,
                children: [
                  { title: 'Items', icon: 'mdi-label', link: '/item/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Brands', icon: 'mdi-heart-box', link: '/brand/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Groups', icon: 'mdi-shape', link: '/itemgroup/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Categories', icon: 'mdi-format-list-bulleted-type', link: '/itemcategory/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Subcategories', icon: 'mdi-format-list-bulleted', link: '/itemsubcategory/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Price List', icon: 'mdi-cash-multiple', link: '/pricelist/list', action: () => this.TOGGLE_DRAWER()},              
                ],
              },
              {
                title: 'Reports',
                icon: 'mdi-circle-small',
                model: false,
                children: [
                  { title: 'Sales Report', icon: 'mdi-circle-small', link: '/salesreport/list', action: () => this.TOGGLE_DRAWER()},
                ],
              },
            ],
          },
          'E-Commerce': {
            title: 'E-Commerce',
            icon: 'mdi-shopping',
            model: false,
            action: () => this.TOGGLE_DRAWER(),
            type: 'sub-menu',
            children: [
              {
                title: 'Orders',
                icon: 'mdi-circle-small',
                model: false,
                children: [
                  { title: 'Online Orders', icon: 'mdi-text-box-multiple', link: '/onlineorder/list', action: () => this.TOGGLE_DRAWER()},              
              ]},
            ],
          },
          'SalesTeam': {
            title: 'Sales Team',
            icon: 'mdi-account-group',
            model: false,
            action: () => this.TOGGLE_DRAWER(),
            type: 'sub-menu',
            children: [
              {
                title: 'Orders',
                icon: 'mdi-circle-small',
                model: false,
                children: [
                  { title: 'Sales Orders', icon: 'mdi-text-box-multiple', link: '/salesorder/team/list', action: () => this.TOGGLE_DRAWER()},             
              ]},
              {
                title: 'Reports',
                icon: 'mdi-circle-small',
                model: false,
                children: [
                  { title: 'Sales by Item', icon: 'mdi-circle-small', link: '/salesreport/team/byitem', action: () => this.TOGGLE_DRAWER()},
              ]},
            ],
          },
          'Logistics': {
            title: 'Logistics',
            icon: 'mdi-truck-delivery',
            model: false,
            action: () => this.TOGGLE_DRAWER(),
            type: 'sub-menu',
            children: [
              { 
                title: 'Purchasing',
                icon: 'mdi-circle-small',
                children: [
                  { title: 'Purchase Orders', icon: 'mdi-text-box-multiple', link: '/purchaseorder/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Purchase Receipts', icon: 'mdi-text-box-multiple', link: '/purchasereceipt/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Purchase Bills', icon: 'mdi-text-box-multiple', link: '/purchasebill/list', action: () => this.TOGGLE_DRAWER()},
                ]},
              {
                title: 'Delivery',
                icon: 'mdi-circle-small',
                model: false,
                children: [
                  { title: 'Loading Orders', icon: 'mdi-circle-list', link: '/loadingorder/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Delivery Orders', icon: 'mdi-circle-small', link: '/deliveryorder/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Routes', icon: 'mdi-circle-small', link: '/route/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Vehicles', icon: 'mdi-circle-list', link: '/vehicle/list', action: () => this.TOGGLE_DRAWER()},
                ],
              },
              {
                title: 'Inventory',
                icon: 'mdi-circle-small',
                model: false,
                children: [
                  { title: 'Inventory', icon: 'mdi-circle-list', link: '/inventory/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Inventory Count', icon: 'mdi-circle-list', link: '/inventorycount/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Inventory Journal', icon: 'mdi-circle-small', link: '/inventoryjournal/list', action: () => this.TOGGLE_DRAWER()},
                ],
              },
              {
                title: 'Places',
                icon: 'mdi-circle-small',
                model: false,
                children: [
                  { title: 'Locations', icon: 'mdi-office-building-marker', link: '/location/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Countries', icon: 'mdi-earth', link: '/country/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Regions', icon: 'mdi-image', link: '/region/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Cities', icon: 'mdi-city', link: '/city/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Townships', icon: 'mdi-home-group', link: '/township/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Districts', icon: 'mdi-home-group', link: '/district/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Rooms', icon: 'mdi-door-sliding', link: '/room/list', action: () => this.TOGGLE_DRAWER()},                
                ],
              },
              {
                title: 'Geolocation',
                icon: 'mdi-circle-small',
                model: false,
                children: [
                  { title: 'Customer Map', icon: 'mdi-circle-small', link: '/geolocation/bycustomer', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Sales Map', icon: 'mdi-circle-small', link: '/geolocation/bycustomersales', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Sale Visits', icon: 'mdi-circle-small', link: '/geolocation/bysalevisits', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Rep Tracking', icon: 'mdi-circle-small', link: '/geolocation/byuser', action: () => this.TOGGLE_DRAWER()},
                ],
              },
            ],
          },
          'Business': {
            title: 'Business',
            icon: 'mdi-domain',
            model: false,
            action: () => this.TOGGLE_DRAWER(),
            type: 'sub-menu',
            children: [
              { 
                title: 'Team',
                icon: 'mdi-circle-small',
                children: [
                { title: 'Business Projects', icon: 'mdi-bell', link: '/businessproject/list', action: () => this.TOGGLE_DRAWER()},
                { title: 'Creative Projects', icon: 'mdi-bell', link: '/creativeproject/list', action: () => this.TOGGLE_DRAWER()},
                { title: 'Web Projects', icon: 'mdi-bell', link: '/webproject/list', action: () => this.TOGGLE_DRAWER()},
              ]},
            ],
          },
          'Marketing': {
            title: 'Marketing',
            icon: 'mdi-heart-multiple',
            model: false,
            action: () => this.TOGGLE_DRAWER(),
            type: 'sub-menu',
            children: [
              { 
                title: 'Communication',
                icon: 'mdi-circle-small',
                children: [
                { title: 'Promotion', icon: 'mdi-tag-heart', link: '/promotion/list', action: () => this.TOGGLE_DRAWER()},
                { title: 'Notification', icon: 'mdi-bell', link: '/notification/list', action: () => this.TOGGLE_DRAWER()},
              ]},
              { 
                title: 'Team',
                icon: 'mdi-circle-small',
                children: [
                { title: 'Marketing Projects', icon: 'mdi-circle-small', link: '/marketproject/list', action: () => this.TOGGLE_DRAWER()},
                { title: 'Creative Projects', icon: 'mdi-bell', link: '/creativeproject/list', action: () => this.TOGGLE_DRAWER()},
                { title: 'Web Projects', icon: 'mdi-tag-heart', link: '/webproject/list', action: () => this.TOGGLE_DRAWER()},
              ]},
            ],
          },
          'DesignWriting': {
            title: 'Design & Writing',
            icon: 'mdi-creation',
            model: false,
            action: () => this.TOGGLE_DRAWER(),
            type: 'sub-menu',
            children: [
              {
                title: 'Team',
                icon: 'mdi-circle-small',
                model: false,
                children: [
                  { title: 'Creative Projects', icon: 'mdi-circle-small', link: '/creativeproject/list', action: () => this.TOGGLE_DRAWER()},
                ],
              },
            ],
          },
          'Finance': {
            title: 'Finance',
            icon: 'mdi-bank',
            model: false,
            action: () => this.TOGGLE_DRAWER(),
            type: 'sub-menu',
            children: [
              {
                title: 'Income',
                icon: 'mdi-circle-small',
                model: false,
                children: [
                  { title: 'Invoices', icon: 'mdi-text-box-multiple', link: '/invoice/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Sales Orders', icon: 'mdi-text-box-multiple', link: '/salesorder/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Sales Invoices', icon: 'mdi-text-box-multiple', link: '/salesinvoice/list', action: () => this.TOGGLE_DRAWER()},
                ],
              },
              {
                title: 'Expenses',
                icon: 'mdi-circle-small',
                model: false,
                children: [
                  { title: 'Bills', icon: 'mdi-text-box-multiple', link: '/bill/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'FA Bills', icon: 'mdi-text-box-multiple', link: '/fabill/list', action: () => this.TOGGLE_DRAWER()},
                ],
              },
              {
                title: 'Transaction',
                icon: 'mdi-circle-small',
                model: false,
                children: [
                  { title: 'Deposits', icon: 'mdi-text-box-multiple', link: '/deposit/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Payments', icon: 'mdi-text-box-multiple', link: '/payment/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Batch Deposits', icon: 'mdi-text-box-multiple', link: '/batchdeposit/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Batch Payments', icon: 'mdi-text-box-multiple', link: '/batchpayment/list', action: () => this.TOGGLE_DRAWER()},
                ],
              },
              {
                title: 'Payroll',
                icon: 'mdi-circle-small',
                model: false,
                children: [
                  { title: 'Payroll', icon: 'mdi-account-box-multiple', link: '/payroll/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Pay Statements', icon: 'mdi-text-box-multiple', link: '/paystatement/list', action: () => this.TOGGLE_DRAWER()}, 
                ],
              },
              {
                title: 'Company',
                icon: 'mdi-circle-small',
                model: false,
                children: [
                { title: 'Customers', icon: 'mdi-folder-multiple', link: '/customer/list', action: () => this.TOGGLE_DRAWER()},   
                { title: 'Vendors', icon: 'mdi-folder-multiple', link: '/vendor/list', action: () => this.TOGGLE_DRAWER()},
                { title: 'Fixed Assets', icon: 'mdi-text-box-multiple', link: '/fixedasset/list', action: () => this.TOGGLE_DRAWER()},              
                { title: 'Pay Methods', icon: 'mdi-folder-multiple', link: '/paymethod/list', action: () => this.TOGGLE_DRAWER()}, 
                { title: 'Currency Rates', icon: 'mdi-text-box-multiple', link: '/currencyrate/list', action: () => this.TOGGLE_DRAWER()},
             
                ],
              },
              {
                title: 'Reports',
                icon: 'mdi-circle-small',
                model: false,
                children: [
                  { title: 'Finance Report', icon: 'mdi-circle-small', link: '/financereport/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Expense Report', icon: 'mdi-circle-small', link: '/expensereport/list', action: () => this.TOGGLE_DRAWER()},
                ],
              },
            ],
          },
          'Accounting': {
            title: 'Accounting',
            icon: 'mdi-list-box',
            model: false,
            action: () => this.TOGGLE_DRAWER(),
            type: 'sub-menu',
            children: [
            {
                title: 'Ledger',
                icon: 'mdi-circle-small',
                model: false,
                children: [
                  { title: 'GL Posting', icon: 'mdi-text-box-multiple', link: '/gl-post/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'GL Mapping', icon: 'mdi-circle-small', link: '/gl-map/list', action: () => this.TOGGLE_DRAWER()}, 
                  { title: 'General Ledger', icon: 'mdi-folder-multiple', link: '/gl-ledger/list', action: () => this.TOGGLE_DRAWER()}, 
                  { title: 'General Journal', icon: 'mdi-folder-multiple', link: '/gl-journal/list', action: () => this.TOGGLE_DRAWER()},
                ],
              },
              {
                title: 'Organization',
                icon: 'mdi-circle-small',
                model: false,
                children: [
                  { title: 'Reports', icon: 'mdi-folder-multiple', link: '/gl-report/list', action: () => this.TOGGLE_DRAWER()},  
                  { title: 'Chart of Accounts', icon: 'mdi-folder-multiple', link: '/account/list', action: () => this.TOGGLE_DRAWER()}, 
                  { title: 'Bank Accounts', icon: 'mdi-circle-small', link: '/bankaccount/list', action: () => this.TOGGLE_DRAWER()},
                ],
              },
            ],
          },
          'Administrative': {
            title: 'Administrative',
            icon: 'mdi-folder-text',
            model: false,
            action: () => this.TOGGLE_DRAWER(),
            type: 'sub-menu',
            children: [
              {
                title: 'Organization',
                icon: 'mdi-circle-small',
                model: false,
                children: [
                  { title: 'Locations', icon: 'mdi-office-building-marker', link: '/location/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Channels', icon: 'mdi-text-box-multiple', link: '/saleschannel/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Department', icon: 'mdi-file-document-check', link: '/department/list', action: () => this.TOGGLE_DRAWER()},  
                ],
              },
              {
                title: 'Team',
                icon: 'mdi-circle-small',
                model: false,
                children: [
                  { title: 'Invoices', icon: 'mdi-text-box-multiple', link: '/invoice/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Bills', icon: 'mdi-file-document-check', link: '/bill/list', action: () => this.TOGGLE_DRAWER()},  
                  { title: 'Claims', icon: 'mdi-file-document-check', link: '/claim/adm/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Reimbursements', icon: 'mdi-file-document-check', link: '/reimbursement/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Bank Accounts', icon: 'mdi-file-document-check', link: '/bankaccount/list', action: () => this.TOGGLE_DRAWER()}, 
                ],
              },
              {
                title: 'Places',
                icon: 'mdi-circle-small',
                model: false,
                children: [
                  { title: 'Countries', icon: 'mdi-earth', link: '/country/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Regions', icon: 'mdi-image', link: '/region/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Cities', icon: 'mdi-city', link: '/city/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Townships', icon: 'mdi-home-group', link: '/township/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Districts', icon: 'mdi-home-group', link: '/district/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Rooms', icon: 'mdi-door-sliding', link: '/room/list', action: () => this.TOGGLE_DRAWER()},                
                ],
              },
            ],
          },
          'HumanResources': {
            title: 'Human Resources',
            icon: 'mdi-account-supervisor-circle',
            model: false,
            action: () => this.TOGGLE_DRAWER(),
            type: 'sub-menu',
            children: [
              { 
                title: 'Employees',
                icon: 'mdi-circle-small',
                children: [
                  { title: 'Employees', icon: 'mdi-account-group', link: '/employee/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Employee Faces', icon: 'mdi-account-group', link: '/employeeface/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Job Postings', icon: 'mdi-account-group', link: '/jobposting/list', action: () => this.TOGGLE_DRAWER()},
                ]
              },
              {
                title: 'Organization',
                icon: 'mdi-circle-small',
                model: false,
                children: [
                  { title: 'Departments', icon: 'mdi-google-classroom', link: '/department/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Users', icon: 'mdi-account', link: '/user/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Performance', icon: 'mdi-google-classroom', link: '/performance/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Policies', icon: 'mdi-google-classroom', link: '/policy/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Holidays', icon: 'mdi-account', link: '/holiday/list', action: () => this.TOGGLE_DRAWER()},
                ],
              },
              {
                title: 'Teams',
                icon: 'mdi-circle-small',
                model: false,
                children: [
                  { title: 'Teams', icon: 'mdi-google-classroom', link: '/team/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Admin Projects', icon: 'mdi-google-classroom', link: '/adminproject/team/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Business Projects', icon: 'mdi-google-classroom', link: '/businessproject/team/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Marketing Projects', icon: 'mdi-google-classroom', link: '/marketproject/team/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Creative Projects', icon: 'mdi-google-classroom', link: '/creativeproject/team/list', action: () => this.TOGGLE_DRAWER()},
                ],
              },
              {
                title: 'Payroll',
                icon: 'mdi-circle-small',
                model: false,
                children: [
                  { title: 'Payroll', icon: 'mdi-account-box-multiple', link: '/payroll/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Pay Statements', icon: 'mdi-text-box-multiple', link: '/paystatement/list', action: () => this.TOGGLE_DRAWER()},                
                  { title: 'Payroll Recurring', icon: 'mdi-file-document', link: '/payrollrecurring/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Payroll Entry', icon: 'mdi-file-document-edit', link: '/payrollentry/list', action: () => this.TOGGLE_DRAWER()},
                ],
              },
              {
                title: 'Time',
                icon: 'mdi-circle-small',
                model: false,
                children: [
                  { title: 'Shifts', icon: 'mdi-clock-time-five', link: '/shift/list', action: () => this.TOGGLE_DRAWER()},     
                  { title: 'Time Tracking', icon: 'mdi-clock-time-five', link: '/timetracking/list', action: () => this.TOGGLE_DRAWER()},
                  { title: 'Time Report', icon: 'mdi-clock-time-five', link: '/timereport/list', action: () => this.TOGGLE_DRAWER()},                
                ],
              },
              {
                title: 'Benefits',
                icon: 'mdi-circle-small',
                model: false,
                children: [
                  { title: 'Claims', icon: 'mdi-file-document-check', link: '/claim/adm/list', action: () => this.TOGGLE_DRAWER()},                
                  { title: 'Requests', icon: 'mdi-file-document-check', link: '/request/list', action: () => this.TOGGLE_DRAWER()},                
                ],
              },
            ],
          },
          'System': {
            title: 'System',
            icon: 'mdi-wan',
            model: false,
            action: () => this.TOGGLE_DRAWER(),
            type: 'sub-menu',
            children: [
              { 
                title: 'Resources',
                icon: 'mdi-circle-small',
                children: [
                { title: 'Companies', icon: 'mdi-domain', link: '/company/list', action: () => this.TOGGLE_DRAWER()},
                { title: 'Users', icon: 'mdi-account', link: '/user/list', action: () => this.TOGGLE_DRAWER()},
                { title: 'Roles', icon: 'mdi-account-check', link: '/role/list', action: () => this.TOGGLE_DRAWER()},
                { title: 'Menus', icon: 'mdi-account-check', link: '/menu/list', action: () => this.TOGGLE_DRAWER()},
                { title: 'Assets', icon: 'mdi-star-box-multiple', link: '/asset/list', action: () => this.TOGGLE_DRAWER()},
                { title: 'Platforms', icon: 'mdi-circle-small', link: '/marketplatform/list', action: () => this.TOGGLE_DRAWER()},
              ]},
              
              {
                title: 'Configuration',
                icon: 'mdi-circle-small',
                model: false,
                children: [
                { title: 'Settings', icon: 'mdi-cog', link: '/systemsetting/list', action: () => this.TOGGLE_DRAWER()},
                { title: 'Languages', icon: 'mdi-earth', link: '/language/list', action: () => this.TOGGLE_DRAWER()},  
                { title: 'Currencies', icon: 'mdi-earth', link: '/currency/list', action: () => this.TOGGLE_DRAWER()},    
                { title: 'Alerts', icon: 'mdi-notification', link: '/alert/list', action: () => this.TOGGLE_DRAWER()},
                { title: 'Query', icon: 'mdi-database-search', link: '/query/list', action: () => this.TOGGLE_DRAWER()},                ],
              },
            ],
          },
        },
                default: {
            title: 'System',
            icon: 'mdi-wan',
            model: false,
            action: () => this.TOGGLE_DRAWER(),
            type: 'sub-menu',
            children: [
              { 
                title: 'Resources',
                icon: 'mdi-circle-small',
                children: [
                { title: 'Users', icon: 'mdi-account', link: '/user/list', action: () => this.TOGGLE_DRAWER()},
                { title: 'Roles', icon: 'mdi-account-check', link: '/role/list', action: () => this.TOGGLE_DRAWER()},
                { title: 'Menus', icon: 'mdi-account-check', link: '/menu/list', action: () => this.TOGGLE_DRAWER()},
              ]},
            ],
          },
        sidebarWidth: 240,
        sidebarMinWidth: 96,
        chatxc: require('@/assets/chatxc-app-icon.png'),
      }
    },
    computed: {
      ...mapState( 'Layout', {
        drawer: state => state.drawer
      } ),
      DRAWER_STATE: {
        get() {
          return this.drawer
        },
        set(newValue) {
          if (newValue === this.drawer) return;
          this.TOGGLE_DRAWER();
        }
      }
    },
    methods: {
      ...mapActions('Layout', [ 'TOGGLE_DRAWER' ]),
      openChat() {
        this.$router.push({ name: 'ChatXC', params: null });
        this.TOGGLE_DRAWER();
      },
    },
    async created(){
      let json = localStorage.getItem('usermenus');
      let user_menus = JSON.parse(json);
      let menu = user_menus.find(menu=>menu.groupcode=='HomePageMenu');
      if(menu==null){
        console.log('menu')
        this.items = [this.default];
      }
      else{
        menu.items.sort((a,b) =>{
            if (b.itemrank > a.itemrank) return -1;
            if (a.itemrank < b.itemrank) return 1;
            return 0;
        });
        for(var i in menu.items){
          let item = menu.items[i];
          let menu_item = this.menu_items[item.itemcode];
          if(menu_item!=undefined) this.items.push(menu_item);
        }
      }


    }
  }
</script>

<style src="./Sidebar.scss" lang="scss"/>
